import React from 'react';
import {ModalWrapper} from './modal-wrapper';

export interface CashProcessingModalProps {
  userEmail?: string;
  imageSrc?: string;
  trackName?: string;
  artist?: string;
  quantity: number;
  transactionHash: string;
  onModalClose: () => void;
  onViewTransactions: () => void;
}

export const CashProcessingModal: React.FC<CashProcessingModalProps> = ({
  userEmail,
  imageSrc,
  trackName,
  artist,
  quantity,
  transactionHash,
  onModalClose,
  onViewTransactions,
}: CashProcessingModalProps) => {
  return (
    <ModalWrapper
      title="Processing your payment"
      copyPrimary={`Once this has completed, you'll get an email confirmation on: ${userEmail}`}
      copySecondary="Your payment has been approved, we're getting your NFT ready."
      withProcessingIndicator
      imageSrc={imageSrc}
      leftButton={{
        label: 'View transactions',
        handlePress: onViewTransactions,
      }}
      rightButton={{
        label: 'Continue browsing',
        handlePress: onModalClose,
      }}
      bottomTransactionHash={transactionHash}
      artist={artist}
      trackName={trackName}
      quantity={quantity}
      onModalClose={onModalClose}
    />
  );
};
